import { Company } from '../Company.model';
import { ExcellenceCenter } from '../ExcellenceCenter.model';
import * as _ from 'lodash';

class DateUndefined {
    date: string;
    undefinedPeriod = false
}

class DateNotApplicable {
    date: string;
    notApplicable = false;
}

class DaysNotApplicable {
    days = 60;
    notApplicable = false;
}

export class VendorInventoryModel {
  _id: string;
  vendor: Company = new Company();
  type: Number;
  isRecurrent: Boolean = true;
  hasContract: Boolean = true;
  active: Boolean = true;
  startDate: string;
  endDate = new DateUndefined();
  readjustmentIndex = 0;
  excellenceCenter = new ExcellenceCenter();
  observation: string;
  noticeDate = new DateNotApplicable();
  readjustmentDate = new DateNotApplicable();
  readjustmentNotificationDays = new DaysNotApplicable();
  noticeNotificationDays = new DaysNotApplicable();
  files: string[] = [];

  constructor(data?: any) {
    this.populate(data);
  }

  populate(data: any) {
    _.forOwn(data, (value, key) => {
      this[key] = value;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/models/vendor-inventory/VendorInventory.model.ts